<template>
<div>
	<router-view #="{Component,route}" >
		<KeepAlive>
			<component ref="routerViewRef" :is="Component" />
		</KeepAlive>
	</router-view>
	<toLoginVue/>
</div>
</template>

<script setup>
import {ref, getCurrentInstance, onMounted, provide, watch, onActivated, onUnmounted, onDeactivated} from 'vue';
const {proxy} = getCurrentInstance();//当前实例

import chatManager from '@/common/js/chatManagerTC';
provide('chatManager', chatManager);


let chatManagerConfig = {
	userID: '',
	chatRegistration: null,
};

import {useStore} from '@/store';
let store = useStore();
let _userInfo = localStorage.getItem('qx2userInfo');
if(_userInfo){
	let _uInfo = JSON.parse(_userInfo);
	store.action.user.updateUser(_uInfo); //设置用户信息
	chatManagerConfig.userID = _uInfo.id;
}
watch(() => store.state.user.id, (newValue, oldValue) => { 
	console.log('watch-user.id',newValue, oldValue);
	if(!newValue && oldValue){
		// 退出登录
       console.log('退出登录');
		chatManager.logout();
		if (chatManagerConfig.chatRegistration?.unregister) {
			chatManagerConfig.chatRegistration.unregister(); // 直接调用返回的注销函数
			chatManagerConfig.chatRegistration = null;
		}
	}else{
		chatLogin(); // 登录
	}
}, { immediate: true });
// 事件监听
let chatRegistrationFn = ()=>{
	chatManagerConfig.chatRegistration = chatManager.registerEvents([
		// SDK 进入 ready 状态时触发，接入侧监听此事件，然后可调用 SDK 发送消息等 API，使用 SDK 的各项功能。
		{
			event: chatManager.TencentCloudChat.EVENT.SDK_READY,//SDK就绪
			handler:(e)=>{
				try{
					proxy.mitter.emit('mittTencentCloudChat', Object.assign({eventType:'SDK_READY'},e));
					console.log('app SDK_READY' ,e);

				}catch (error) {
					console.log('app error ', error);
			
				}
			},
		},
		//SDK 收到推送的单聊、群聊、群提示、群系统通知的新消息。
		{
			event:chatManager.TencentCloudChat.EVENT.MESSAGE_RECEIVED,//接收信息
			handler:(e)=>{
				try {
					proxy.mitter.emit('mittTencentCloudChat', Object.assign({eventType:'MESSAGE_RECEIVED'},e));
					console.log('app MESSAGE_RECEIVED', e.data);
					//如果是广告消息
					if(e.data[0]?.customType=="AdvertisingPushMessage"){
						proxy.AdvShowCallback(e.data[0]?.customExts);//推送广告展示
					}
				    
				}catch (error) {
					console.log('app error ', error);
				    
				}
			}
		},
		// 会话列表更新，event.data 是包含 Conversation 对象的数组
		{
			event:chatManager.TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED,
			handler: (e)=>{
				try{
					
					proxy.mitter.emit('mittTencentCloudChat', Object.assign({eventType:'CONVERSATION_LIST_UPDATED'},e));
					let ulist = e.data.filter(f=>f.messageRemindType==chatManager.TencentCloudChat.TYPES.MSG_REMIND_ACPT_AND_NOTE);
					ulist = ulist.filter(f=>f.type == chatManager.TencentCloudChat.TYPES.CONV_C2C || 
					(f.type == chatManager.TencentCloudChat.TYPES.CONV_GROUP && f.subType==chatManager.TencentCloudChat.TYPES.GRP_PUBLIC) || 
					(f.type == chatManager.TencentCloudChat.TYPES.CONV_GROUP && f.subType==chatManager.TencentCloudChat.TYPES.GRP_COMMUNITY));
					ulist = ulist.filter(f=>f.unreadCount);
					let unreadCount = ulist.map(f=>f.unreadCount).reduce((a,b)=>a+b, 0);
					store.action.chater.setChater({unreadCount});
					proxy.mitter.emit('mittTencentCloudChat', {eventType:'bottom_count_change',unreadCount});
					console.log('app CONVERSATION_LIST_UPDATED',unreadCount);
				}catch (error) {
				    console.log('app error1 ', error);
				}
			}
		},
		// SDK 收到了消息的已读回执通知，消息接收方调用 sendMessageReadReceipt 时消息发送方会收到此事件
		{
			event:chatManager.TencentCloudChat.EVENT.MESSAGE_READ_RECEIPT_RECEIVED,
			handler: (e)=>{
				proxy.mitter.emit('mittTencentCloudChat', Object.assign({eventType:'MESSAGE_READ_RECEIPT_RECEIVED'},e));
				proxy.mitter.emit('message_read_receipt_received', e);
				console.log('app MESSAGE_READ_RECEIPT_RECEIVED');
			}
		},
		// SDK 好友申请列表更新时触发
		{
			event:chatManager.TencentCloudChat.EVENT.FRIEND_APPLICATION_LIST_UPDATED,
			handler:(e)=>{
				try {
					proxy.mitter.emit('mittTencentCloudChat', Object.assign({eventType:'FRIEND_APPLICATION_LIST_UPDATED'},e));
					console.log('app FRIEND_APPLICATION_LIST_UPDATED');
					// friendApplicationList - 好友申请列表 - [FriendApplication]
					// unreadCount - 好友申请的未读数
					const { friendApplicationList, unreadCount } = e.data;
					// 发送给我的好友申请（即别人申请加我为好友）
					// console.log('applicationSentToMe', friendApplicationList);
					const applicationSentToMe = friendApplicationList.filter((friendApplication) => friendApplication.type === chatManager.TencentCloudChat.TYPES.SNS_APPLICATION_SENT_TO_ME || !friendApplication.type);
					store.action.chater.setChater({applicationCount:applicationSentToMe.length});
					proxy.mitter.emit('mittTencentCloudChat', {eventType:'bottom_count_change',applicationCount:applicationSentToMe.length});
				    
				}catch{
					console.log('app error2 ', error);
				}
			}
		},
				{
			event:chatManager.TencentCloudChat.EVENT.PINNED_GROUP_MESSAGE_UPDATED,
			handler:(e)=>{
				proxy.mitter.emit('mittTencentCloudChat', Object.assign({eventType:'PINNED_GROUP_MESSAGE_UPDATED'},e));
				console.log('app PINNED_GROUP_MESSAGE_UPDATED');
				proxy.mitter.emit('pinGroupMessage', e.data);
			}
		},
				// 撤回
			{
			event:chatManager.TencentCloudChat.EVENT.MESSAGE_REVOKED,//接收信息
			handler:(e)=>{
				try {
					proxy.mitter.emit('mittTencentCloudChat', Object.assign({eventType:'MESSAGE_REVOKED'},e));
					console.log('app MESSAGE_REVOKED', e.data);
				    
				}catch (error) {
					console.log('app error ', error);
				    
				}
			}
		},
		// 好友状态更新
		{
			event:chatManager.TencentCloudChat.EVENT.USER_STATUS_UPDATED,//接收信息
			handler:(e)=>{
				try {
					proxy.mitter.emit('mittTencentCloudChat', Object.assign({eventType:'USER_STATUS_UPDATED'},e));
					console.log('app USER_STATUS_UPDATED', e.data);
				    
				}catch (error) {
					console.log('app error ', error);
				    
				}
			}
		},
	]);
}
// 登录
// let chatLoginFn = ()=>{
// 	(function _chatLogin(){
// 		// if (chatManager.isLoggedIn()) return; //已登陆或没有用户ID则不登录
// 		chatManager.login(chatManagerConfig.userID, proxy.request).then(res=>{
// 			console.log(res,'chatManager.login-res');
// 		}).catch(err=>{
// 			console.log(err,'chatManager.login-err');
// 		})
// 		if(!chatManager.isLoggedIn()){
// 			proxy.awaitTime(3000,()=>{
// 				_chatLogin();
// 			})
// 		}
// 	})();
// }
function chatLogin(){
	console.log('正在登录腾讯chat');
		return chatManager.login(chatManagerConfig.userID).then(res=>{
			console.log('chatManager.login:',res);
			if(!res.succ){
				setTimeout(()=>{
					console.log('正在重试登录腾讯chat');
					chatLogin();
				},5000)
			}else{
				
			}
		}).catch(err=>{
			console.log('chatManager.login-err:',err);
			
		})
	}

onUnmounted(()=>{
	window.backOffConfirm = null;
  proxy.mitter.off('popup:open', onPopupOpen);
  proxy.mitter.off('popup:close', onPopupClose);
	chatManager.destroy();
	if (chatManagerConfig.chatRegistration?.unregister) {
		chatManagerConfig.chatRegistration.unregister(); // 直接调用返回的注销函数
		chatManagerConfig.chatRegistration = null;
	}
})
const defaultResDomains = ref('')

const hasPopup = ref(false);
const popupInfo = ref(null);
// 创建事件监听
const handleBackConfirm = () => {
  console.log("全局返回确认处理，当前弹窗状态:", hasPopup.value, popupInfo.value);
  if (hasPopup.value && popupInfo.value) {
    // 触发弹窗的自定义返回确认逻辑
	console.log("触发弹窗的自定义返回确认逻辑");
    proxy.mitter.emit('popupBackConfirm', popupInfo.value, (result) => {
      if (result === true) {
        // 弹窗自行处理了返回逻辑
        return true;
      } else {
        // 默认关闭弹窗
        closeCurrentPopup();
        return true;
      }
    });
    return true; // 已处理
  }
  
  return false; // 未处理
};
//被动获取token
let getTokenInfoCallback = (res) => {
    console.log('getTokenInfoCallback',res);
	let result=JSON.parse(res);
	console.log('getTokenInfoCallback result',res.result);
	//更新token
	localStorage.setItem('qx2token', result.token);
}

//app物理键返回时触发
let onAppBackPressCallback = () => {
  console.log('onAppBackPressCallback');
  if (window.__pageLevel.value > 0) {
    console.log('当前页面层级:', window.__pageLevel.value)
    window.__pageLevel.value--
    console.log('当前页面层级:', window.__pageLevel.value)
	proxy.navBack();
	// if(proxy.constant?.Source==4){
	// 	onAppBackPress.postMessage('no')
	// }

    return true
  } else {
	// if(proxy.constant?.Source==4){
	// 	onAppBackPress.postMessage('no')
	// }
    return false
  }
}

// 关闭当前弹窗
const closeCurrentPopup = () => {
  if (popupInfo.value && popupInfo.value.close) {
    popupInfo.value.close();
  }
  hasPopup.value = false;
  popupInfo.value = null;
};

// 监听弹窗打开事件
const onPopupOpen = (info) => {
  hasPopup.value = true;
  popupInfo.value = info;
  console.log("弹窗打开:", info);
};

// 监听弹窗关闭事件
const onPopupClose = () => {
  hasPopup.value = false;
  popupInfo.value = null;
  console.log("弹窗关闭");
};
//H5页面加载完成
let h5LoadFinishedCallback = () => {
	try {
    h5LoadFinished.postMessage('h5LoadFinishedCallback');
    console.log('h5LoadFinished 调用成功');
  } catch (error) {
    console.log('h5LoadFinished 不存在或调用失败:', error);
  }
}

// 统一的回调方法
function notifyAppLoaded() {
  if (window.h5LoadFinishedCallback) {
	console.log('h5LoadFinishedCallback called');
    window.h5LoadFinishedCallback();
  }
}
onMounted(()=>{
	window.backOffConfirm = handleBackConfirm;
	window.getTokenInfoCallback = getTokenInfoCallback;
	window.h5LoadFinishedCallback=h5LoadFinishedCallback;
	window.onAppBackPress=onAppBackPressCallback;//app返回
  // 监听弹窗事件
  proxy.mitter.on('popup:open', onPopupOpen);
  proxy.mitter.on('popup:close', onPopupClose);
	// Phase E: 统一订阅 request 层最终错误，使用 ElMessage 展示（H5 项目请改为对应 Toast）
	console.log('App onMounted');
	// 这里可以执行首次启动的逻辑
	//从存储中获取到qx2StartUp
	const qx2StartUp = localStorage.getItem('qx2StartUp');
	if (qx2StartUp) {
		// 如果存在，获取到configData下面的defaultResDomains并抛出供全局使用
				try {
					const parsedData = JSON.parse(qx2StartUp)
					defaultResDomains.value = parsedData.configData?.defaultResDomains || ''
				} catch (error) {
					defaultResDomains.value = ''
			}
		
	}
	//获取是否修改过昵称
	let qx2userInfo = localStorage.getItem('qx2userInfo');
	if(qx2userInfo){
		_userInfo = JSON.parse(qx2userInfo);
		if(_userInfo?.updatedNickname==0 && _userInfo?.updatedNickname){ //字段存在并且为0的情况下
			proxy.routerRreplace({ path:'/personal_register',query:{updatedNickname:true} });
		}
	}
	//默认开启首页居中广告
	localStorage.setItem('hasLaunched', 'true');
	proxy.setVariable(); //全局样式变量动态设置
	proxy.watchVersion(); //监听版本更新
	proxy.getStartUp();
	if(proxy.constant?.Source==4){
		notifyAppLoaded();
	}
	chatRegistrationFn();
	const eventBus = proxy?.mitter;
	if(!eventBus || typeof eventBus.on !== 'function') {
		console.error('Event bus not ready: proxy.mitter is undefined');
	}
	// if (!eventBus?.on) {
	// 	console.error('Event bus not ready: proxy.mitter is undefined or invalid');
	// 	return;
	// }
	eventBus.on('request:error', ({ message }) => {
		if (message) proxy.showToast?.({ message, type: 'error', duration: 3000 });
	});
	eventBus.on('userLogined', (userInfo) => {
		console.log('userLogined', userInfo);
		localStorage.setItem('qx2userInfo', JSON.stringify(userInfo));
		store.action.user.resetUserStore();
		store.action.user.updateUser(userInfo);
		(async function _chatLogin() {
			if (chatManager.isLoggedIn() && chatManager.ChatClient()?.isReady()) return;
			await chatManager.login(userInfo.id).then(res => {
				console.log(res, 'chatManager.login-res');
			}).catch(err => {
				console.log(err, 'chatManager.login-err');
			});
			if (!chatManager.isLoggedIn()) {
				setTimeout(() => {
					_chatLogin();
				}, 3000);
			}
		})();
	});

	eventBus.on('triggerLogin', ( ) => {
		// const redirect = isH5 ? router.currentRoute.value : window.location.hash.replace('#/', '');
		localStorage.removeItem('qx2token');
		localStorage.removeItem('qx2userInfo');
		store.action.user.resetUserStore();
		store.action.chater.clearChater();
	});
	
});

provide('defaultResDomains', defaultResDomains)

</script>

<style lang="less">
// @font-face {
// 	font-family: 'YouSheBiaoTiHei';
// 	// src: url('~@/assets/fonts/YouSheBiaoTiHei.ttf');
// 	src: url('/public/assets/fonts/YouSheBiaoTiHei.ttf');
// 	font-display: swap;
// }
body{
	margin: 0;
	padding: 0;
}
input{
	border: none;
	outline: none;
	background: transparent;
	&::selected{
		background: transparent;
	}
	&::-internal-autofill-selected{
		background-color: transparent;
	}
}
img{
	object-fit: cover;
}
:root { 
	--pageHeight: 100vh;
	--footerHeight: 60px;
	--active-font-color: #52A401; //全局字体激活色
	--horizontal-gradient: linear-gradient(286deg, #52A401 0%, #D2D54C 100%); //横条渐变色
	--vertical-gradient: linear-gradient(16deg, #52A401 0%, #D2D54C 100%); //竖条渐变色
	--theme-background-color: linear-gradient(214deg, #F0FAF2 0%, #FCFCFC 100%); //主题背景色(横向)
	--reverse-theme-background-color: linear-gradient(146deg, #F0FAF2 0%, #FCFCFC 100%); //主题背景色(横向反)
	--vertical-theme-background-color: linear-gradient(180deg, #F0FAF2 0%, #FCFCFC 100%); //主题背景色(竖向)
	--navHeight: 50px; //导航栏高度
	--statsHeight: 0px; //导航栏高度
	--imgbgcolor: transparent; //图片背景颜色
	--header-Index: 999;
	--matchHeadHeight: 210px; //匹配比赛详情页头图高度
	
	width: 375px;
	height: 100%;
	margin: 0 auto;
	background: #FFFFFF;
	font-size: 12px;
}
// 一级页面header的高度
.mpstatusbarfiled{
	height: var(--statsHeight);
	background: var(--theme-background-color);
}
.headerfiled{
	width: 375px;
	height: var(--navHeight);
	background: var(--theme-background-color);
}
// 标题共用样式
.title-box {
	width: 100%;
	height: 40px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	box-sizing: border-box;
	position: relative;
	.title{
		position: relative;
		z-index: 0;
		font-size: 16px;
		color: #000000;
		font-weight: bold;
		padding-left: 13px;
		height: 40px;
		display: flex;
		align-items: center;
		&:after{
			content: '';
			width: 4px;
			height: 12px; //这里用px,不要用px,px可以固定位置，不发生偏移，不受手机尺寸影响
			position: absolute;
			z-index: -1;
			left: 0%;
			top: 50%;
			transform: translateY(-50%);
			background: var(--vertical-gradient);
		}
		&.noattach{
			&:after{
			}
		}
		.titleadd{
			font-size: 14px;
			color: #6D7278;
			font-weight: 400;
			padding: 0 10px;
		}
	}
	.btn {
		height: 40px;
		display: flex;
		align-items: center;
		.seemoretext{
			color: #6D7278;
			font-size: 12px;
		}
		.icon{
			width: 5px;
			height: 9px;
			margin-left: 5px;
			&.delimg{
				width: 15px;
				height: 14px;
			}
		}
	}
}
.sling {
	position: relative;
	&:after{ 
		content: '';
		position: absolute;
		bottom: -4px;
		left: 50%;
		transform: translateX(-50%);
		width: 18px;
		height: 4px;
		background: var(--horizontal-gradient);
	}
}
/* 隐藏滚动条，但依旧具备可以滚动的功能 */
.hide_scroll::-webkit-scrollbar {
	display: none;
	width: 0!important;
	height: 0!important;
	color: transparent;
	background: transparent;
	-moz-appearance: none;
	-webkit-appearance: none;
	scrollbar-width: none;
}
.scroll-x{
	overflow: hidden;
	overflow-x: auto;
	white-space: nowrap;
}
.scroll-y{
	overflow: hidden;
	overflow-y: auto;
}
.nodata{
	width: 100%;
	height: 80px;
	color: #666;
	font-size: 14px;
	margin-top: 60px;
}

// 公共样式
.flex-center{
	display: flex;
	justify-content: center;
	align-items: center;
}
.flex-wrap-space-between{
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}
.flex-space-between-center{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.flex-start{
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.flex-end{
	display: flex;
	justify-content: flex-end;
	align-items: center;
}
.ellipsis{
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.ellipsis2{
	word-break: break-all;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2; /* 这里是超出几行省略 */
	overflow: hidden;
}
.opacity0{
	opacity: 0;
}
.padd0{
	padding: 0 !important;
}
.padding010{
	padding: 0 10px;
	box-sizing: border-box;
}
.redcolor{
	color: #FE2323 !important;
}
.bluecolor{
	color: #3067FF !important;
}
.greencolor{
	color: #52A401 !important;
}
@keyframes blink {
  0%, 100% {
	opacity: 1;
  }
  50% {
	opacity: 0;
  }
}
</style>
